module.exports = __webpack_public_path__ + "images/greenwheels_smallf983a427b3ccc1aeb59f17fcc68d0078.png";